"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhysicsLoader = void 0;
const wasmLoader_1 = require("./wasmLoader");
const PhysicsLoader = (path, callback) => {
    if (typeof window !== 'undefined')
        window.__loadPhysics = true;
    wasmLoader_1.default(path, () => {
        Ammo().then(() => {
            callback();
        });
    });
};
exports.PhysicsLoader = PhysicsLoader;
//# sourceMappingURL=physicsLoader.js.map